/**
 * Initializes a modal for the creation or linking of a third party company
 * Requires
 * 			window['routes/agent.voe-orders.send-to-new-third-party-company']
 * 		And
 * 			window['routes/agent.voe-orders.send-to-third-party-company']
 * defined
 */
import {createModal} from "../../helpers/modal";
import {initTomSelectInput} from "../../helpers/inputs/tom-select/tom-select";
import {clearFeedbacksByName, clearInputsByName, fillInputsByName, getInputsByName} from "../../helpers/forms";
import {loading, stopLoading} from "../../helpers/loading";
import Axios from "axios";
import {handleAjaxSuccess} from "../../helpers/swalHelper";
import handleAjaxError from "../../helpers/handleAjaxError";
import Swal from "sweetalert2";

function createSendToThirdPartyCompanyModal() {
	const createCompanyFields = [
		'name',
		'email',
		'phone',
		'fax',
	];
	const useExistingFields = [
		'third_party_company_id'
	];
	const alwaysOnFields = [
		'notes'
	];

	const allFields = [
		...createCompanyFields,
		...useExistingFields,
		...alwaysOnFields,
	]

	const modal = createModal({
		modalContainer: document.querySelector('.send-to-third-party-modal'),
		init() {
			// Make modal height auto sized
			const body = this.modalContainer.querySelector('.modal-body');

			body.style.minHeight = 'unset';
			body.style.height = 'auto';

			// Init buttons
			const toggleButton = this.modalContainer.querySelector('.toggle-view-button');
			if (toggleButton) {
				toggleButton.addEventListener('click', () => {
					this.toggleView();
				})
			}

			const submitButton = this.modalContainer.querySelector('.submit-button');
			if (submitButton) {
				submitButton.addEventListener('click', () => {
					this.submitModal();
				})
			}


			// Init select
			const companySelect = this.modalContainer.querySelector('select[name="third_party_company_id"]');
			if (companySelect) {
				initTomSelectInput(companySelect);
			}
		},
		getCurrentView() {
			return this.modalContainer
				.querySelector('.link-existing-section')
				.classList
				.contains('d-none') ?
				'create-new' : 'use-existing';
		},
		getLinkExistingSection() {
			return this.modalContainer
				.querySelector('.link-existing-section');
		},
		getCreateNewSection() {
			return this.modalContainer
				.querySelector('.create-new-section');
		},
		toggleView() {
			const currentView = this.getCurrentView();
			const submitButton = this.modalContainer.querySelector('.submit-button');
			const toggleButton = this.modalContainer.querySelector('.toggle-view-button');

			// Swap buttons text
			const tempText = submitButton.innerHTML;
			submitButton.innerHTML = toggleButton.innerHTML;
			toggleButton.innerHTML = tempText;

			if (currentView === 'use-existing') {
				this.getLinkExistingSection().classList
					.add('d-none');
				this.getCreateNewSection().classList
					.remove('d-none');
			} else {
				this.getLinkExistingSection().classList
					.remove('d-none');
				this.getCreateNewSection().classList
					.add('d-none');
			}
		},
		submitModal() {
			const view = this.getCurrentView();

			if (view === 'create-new') {
				submitNewCompany();
			} else {
				submitExistingCompany();
			}
		}

	})

	modal.__display = modal.display;

	modal.display = function () {
		clearInputsByName(this.modalContainer, allFields);

		// If possible, retrieve already existing notes
		let notes = '';

		const statusCard = document.querySelector('.voe-status-card');
		if (statusCard) {
			const statusCardNotes = statusCard.querySelector('textarea[name="notes"]');
			if (statusCardNotes) {
				notes = statusCardNotes.value;
			}
		}

		if (notes) {
			fillInputsByName(this.modalContainer, {
				notes,
			});
		}

		this.__display();
	}

	return modal;


	/**
	 * Methods
	 */

	function submitNewCompany() {
		clearFeedbacksByName(modal.modalContainer, allFields);

		const data = getInputsByName(modal.modalContainer, createCompanyFields);

		addAlwaysOnFields(data);

		loading();

		Axios.post(window['routes/agent.voe-orders.send-to-new-third-party-company'], data)
			.then(handleAjaxSuccess)
			.catch(error => handleAjaxError(error, modal.modalContainer))
			.finally(stopLoading);
	}

	function submitExistingCompany() {
		clearFeedbacksByName(modal.modalContainer, allFields);

		const companyId = modal.modalContainer.querySelector('select[name="third_party_company_id"]').value;

		if (!companyId) {
			// Error out if no company selected
			Swal.fire({
				title: 'Please select a 3rd party company',
				icon: 'warning',
			}).then();

			return;
		}

		const data = {};

		addAlwaysOnFields(data);

		loading();

		const route = window['routes/agent.voe-orders.send-to-third-party-company']
			.replace('__COMPANY__', companyId);

		Axios.post(route, data)
			.then(handleAjaxSuccess)
			.catch(error => handleAjaxError(error, modal.modalContainer))
			.finally(stopLoading);
	}

	function addAlwaysOnFields(data) {
		const alwaysOnValues = getInputsByName(modal.modalContainer, alwaysOnFields);

		Object.keys(alwaysOnValues).forEach(key => {
			data[key] = alwaysOnValues[key];
		})
	}
}

export {createSendToThirdPartyCompanyModal}
